module.exports = __webpack_public_path__ + "assets/diaogang2.ce9c9575.svg";